import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children }) => {
    const { user } = useAuth();
    const location = useLocation();
    if (user === undefined) {
        return (
            <div className="min-h-screen flex items-center justify-center text-muted-foreground">
                Checking session…
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/admin/login" state={{ from: location }} replace />;
    }
    return children;
};

export default ProtectedRoute;
